import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      currentPath: this.$router.currentRoute.path,
      showNav: false
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      currentUser: 'currentUser',
      isStaff: 'isStaff'
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => this.$router.push('/login'))
    },
    toggleNavbar() {
      this.showNav = !this.showNav
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/script.js